// extracted by mini-css-extract-plugin
module.exports = {"preview":"preview_preview__qzBEu","image":"preview_image__gFpV0"};